import Constants from '@/common/constants';

import { TEapAssignment } from '../types/main';
import { isDeadlineOverdue } from './deadline';

export const getStatusClassIcon = (assignment: TEapAssignment) => {
  //cir-done //cir-late //cir-close //cir-inWork
  if (assignment.postponed) return 'cir-close';
  if (assignment.statusId == Constants.eapAssignemntStatusDoneId) return 'cir-done';
  return isDeadlineOverdue(assignment) ? 'cir-late' : 'cir-inWork';
};

export const getStatusClass = (assignment: TEapAssignment) => {
  //status-done //status-late //status-close //cir-inWork
  if (assignment.postponed) return 'status-close';
  if (assignment.statusId == Constants.eapAssignemntStatusDoneId) return 'status-done';

  return isDeadlineOverdue(assignment) ? 'status-late' : 'status-inWork';
};
